export const PASSWORD_REQUIREMENTS = "^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[`~!@#$%^&*()_+=\\-{}|\\\\:;\"'<>,.?/]).*$";
export const EMAIL_REGEX = "^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$";
export const FILENAME_VALID_CHARACTERS = /^[a-zA-ZÀ-Ÿ0-9._\-\s]+$/;
